import by from './by'

const on = predicate => ({
  add: value => (predicate ? [value] : [])
})

const { add } = on(true)

const classes = (...array) => array.reduce(by.aggregate.concat, []).join(' ')

export { on, add, classes }
